module.exports = __webpack_public_path__ + "static/media/promoDefault.390075aa.png";